import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// Styled by .yz-clear-filters in styles/listing.css (dark mode included).
// Pages pass `disabled` while no filter is applied; the button is only shown
// once there is something to clear.
export default function ClearFiltersButton({ onClick, disabled = false, className = '' }) {
  if (disabled) return null;

  return (
    <OverlayTrigger overlay={<Tooltip>Clear all filters</Tooltip>}>
      <span style={{ display: 'inline-block' }}>
        <button type="button" className={`yz-clear-filters ${className}`} onClick={onClick}>
          <i className="ph ph-funnel-x"></i>
        </button>
      </span>
    </OverlayTrigger>
  );
}
